// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Navbar } from 'react-bootstrap';
import Navigation from '../Navigation';
import Toaster from '../Toaster';
import LoadingBar from 'react-redux-loading-bar';
import HeaderLocationSearch from './HeaderLocationSearch';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import BackToHomeArrow from '../BackToHome/BackToHomeArrow';

import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';
import history from '../../core/history';
import Link from '../Link';
import Logo from '../Logo';
import messages from '../../locale/messages';

import closeIcon from '/public/SiteIcons/loginClose.svg';
/* import eslipinLogo from '/public/eslipin-logo-primary-blue.png';
import LogoSecundarioBlue from '/public/eslipin-logo-secundario-blue.png'; */

import s from './Header.css';

function HomeHeader(props) {
  const { showMenu, layoutType, homeHeaderOnly, account, isNotHomePage, whiteHeader } = props;
  const [homeData, setHomeData] = useState({
    isOpen: 0,
    fixedBgClass: '',
    scrollLogo: false
  });
  const { isOpen, fixedBgClass, scrollLogo } = homeData;
  // Solo cliente: en SSR `history` no existe y `location` es undefined.
  // Si la rama con flecha se renderizara en el primer paso del cliente,
  // el HTML diverge del servidor (hydration mismatch) y el click muere.
  const [isClient, setIsClient] = useState(false);

  let location, homeHeader, layoutFive, isTransparentHeader;

  if (history.location) {
    location = history.location.pathname;
  }

  const isActive = (path) => location === path;
  const showBackArrow = isClient && ['/about', '/whyhost', '/safety', '/travel'].includes(location);

  homeHeader = { ['homeHeader']: location === '/' || location === '/home' };
  layoutFive = (whiteHeader !== true && Number(layoutType) === 5) ? fixedBgClass : '';
  isTransparentHeader = whiteHeader === true ? false : (layoutFive === 'fixedTransparentHeader');

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && Number(layoutType) === 5) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      handleScroll();
    }
  }, [layoutType]);

  const handleMenu = () => {
    const { showMenu, toggleOpen, toggleClose } = props;
    showMenu ? toggleClose() : toggleOpen();
  }

  const openMenu = () => {
    setHomeData(prevObject => ({ ...prevObject, isOpen: 1 }));
  }

  const openClose = () => {
    setHomeData(prevObject => ({ ...prevObject, isOpen: 0 }));
  }

  const handleScroll = () => {
    let top = document.documentElement.scrollTop || document.body.scrollTop,
      isWeb = window.matchMedia('(min-width: 1300px)').matches;
    let fixedBgClass = '', scrollLogo = false;
    if (isWeb && top >= 410) {
      fixedBgClass = 'fixedBgHeader';
      scrollLogo = true;
    } else if (isWeb) {
      fixedBgClass = 'fixedTransparentHeader';
    }
    setHomeData(prevObject => ({ ...prevObject, fixedBgClass, scrollLogo }));
  }

  return (
    <div>
      <div className={s.root}>
        <Toaster />
        <LoadingBar />
        <div>
          <div className={cx(s.container, isTransparentHeader && 'containerTransparent')}>
          <Navbar className={
            cx(
              'commonHeader',
              homeHeader,
              layoutFive,
            )}
            expanded={showMenu}
            onToggle={handleMenu}
          >
            <div className={cx(s.headerFlexBox, s.innerPageHeader)} style={{ backgroundColor: isTransparentHeader ? 'transparent' : '#fff' }}>
              {showBackArrow ? (
                <div className={cx(s.logoGroup)}>
                  <BackToHomeArrow />
                  <Navbar.Header className={cx('logoPadding', (!showMenu ? 'normalPosition' : 'fixedPosition'))}>
                    <Navbar.Brand className={(s.homeLogo)}>
                      {/* <Link to={"/"} className={cx(s.brand, s.brandImg)}>
                        <img src={LogoSecundarioBlue} alt="Eslipin" />
                      </Link> */}
                      <Logo link={"/"} className={cx(s.brand, s.brandImg)} scrollLogo={scrollLogo} />
                    </Navbar.Brand>
                  </Navbar.Header>
                </div>
              ) : (
              <Navbar.Header className={cx('logoPadding', (!showMenu ? 'normalPosition' : 'fixedPosition'))}>
                <Navbar.Brand className={(s.homeLogo)}>
                  {/* <Link to={"/"} className={cx(s.brand, s.brandImg)}>
                    <img src={LogoSecundarioBlue} alt="Eslipin" />
                  </Link> */}
                  <Logo link={"/"} className={cx(s.brand, s.brandImg)} scrollLogo={scrollLogo} />
                </Navbar.Brand>
              </Navbar.Header>
              )}
              {(isTransparentHeader || whiteHeader === true) && <div className={cx(s.headerCenterNav, 'hidden-xs', 'hidden-sm', 'hidden-md')}>
                <Link to="/about" className={cx(s.headerCenterLink, whiteHeader === true && s.headerCenterLinkPrimary, isTransparentHeader && s.liquidglassNav, isActive('/about') && s.headerCenterLinkActive)}>
                  <FormattedMessage {...messages.about} />
                </Link>
                <span className={cx(s.navSeparator, isTransparentHeader && s.liquidglassSeparator)}></span>
                <Link to="/whyhost" className={cx(s.headerCenterLink, whiteHeader === true && s.headerCenterLinkPrimary, isTransparentHeader && s.liquidglassNav, isActive('/whyhost') && s.headerCenterLinkActive)}>
                  <FormattedMessage {...messages.becomeAHost} />
                </Link>
                <span className={cx(s.navSeparator, isTransparentHeader && s.liquidglassSeparator)}></span>
                <Link to="/safety" className={cx(s.headerCenterLink, whiteHeader === true && s.headerCenterLinkPrimary, isTransparentHeader && s.liquidglassNav, isActive('/safety') && s.headerCenterLinkActive)}>
                  <FormattedMessage {...messages.safetyInsurance} />
                </Link>
                <span className={cx(s.navSeparator, isTransparentHeader && s.liquidglassSeparator)}></span>
                <Link to="/contact" className={cx(s.headerCenterLink, whiteHeader === true && s.headerCenterLinkPrimary, isTransparentHeader && s.liquidglassNav, isActive('/contact') && s.headerCenterLinkActive)}>
                  <FormattedMessage {...messages.contactForm} />
                </Link>
              </div>}
              <div className={cx('hidden-lg', 'positionRelative')} onClick={openMenu}>
                <DropDownMenu isTransparentHeader={isTransparentHeader} />
              </div>
              {
                isNotHomePage && whiteHeader !== true && <Navbar.Form pullLeft className={('hidden-xs', s.breakPoint)}>
                  <HeaderLocationSearch />
                </Navbar.Form>
              }
              <div className={cx({ [s.menuOpen]: isOpen == 1 }, s.mobileMenu, 'homeMobileMenu')}>
                <div className={cx(s.closeButtonPosition, 'hidden-lg')}>
                  <div className={cx(s.closeColor, 'closeColorRTL', 'svgImg')} onClick={openClose} >
                    <img src={closeIcon} />
                  </div>
                </div>
                <div onClick={openClose}>
                  <Navigation openClose={isOpen} homeHeaderOnly={homeHeaderOnly}
                    homePage
                    isTransparentHeader={isTransparentHeader}
                  />
                </div>
              </div>
            </div>
          </Navbar>
        </div>
        </div>
      </div>
    </div>
  );
}

HomeHeader.propTypes = {
  borderLess: PropTypes.bool,
  showMenu: PropTypes.bool,
  whiteHeader: PropTypes.bool,
  isNotHomePage: PropTypes.bool,
  toggleOpen: PropTypes.any.isRequired,
  formatMessage: PropTypes.any,
  checked: PropTypes.any
};

HomeHeader.defaultProps = {
  borderLess: false,
  showMenu: false,
  whiteHeader: false
}

HomeHeader = reduxForm({
  form: 'HomeHeaderForm', // a unique name for this form
})(HomeHeader);

const mapState = (state) => ({
  showMenu: state.toggle.showMenu,
  layoutType: state.siteSettings.data.homePageType,
  account: state.account.data
});

const mapDispatch = {
  toggleOpen,
  toggleClose
};


export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
)(HomeHeader);
